import React from "react";
import { Button, Space } from "antd";
import GenericModal from "./GenericModal";
import {
  LockOutlined,
  ArrowUpOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const RestrictedFeatureModal = ({
  visible,
  onCancel,
  featureName = "Pay Bill",
}) => {
  const navigate = useNavigate();
  const handleUpgrade = () => {
    onCancel();
    navigate("/wallet", { state: { openTierModal: true } });
  };

  return (
    <>
      <GenericModal
        open={visible}
        onCancel={onCancel}
        footer={null}
        centered
        width={400}
        className="restricted-feature-modal"
        closeIcon={
          <CloseOutlined className="text-gray-400 hover:text-gray-600" />
        }
      >
        <div className="py-8 px-4 text-center">
          <div className="bg-blue-100 p-3 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
            <LockOutlined style={{ fontSize: "36px", color: "#1d4ed8" }} />
          </div>

          <h2 className="text-3xl font-gilroyBold text-gray-800 mb-4">
            Tier 2 Feature Only
          </h2>

          <p className="block mb-8">
            {featureName} is currently available for Tier 2 users only. Please
            upgrade your account to enjoy this feature and more.
          </p>

          <Space direction="vertical" className="w-full" size="middle">
            <button
              type="primary"
              size="large"
              block
              icon={<ArrowUpOutlined />}
              onClick={handleUpgrade}
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-gilroyBold w-full transition-colors"
            >
              Upgrade to Tier 2
            </button>

            <button
              type="text"
              size="large"
              block
              onClick={onCancel}
              className="text-gray-500 font-gilroyBold hover:text-gray-700 text-xl"
            >
              Maybe later
            </button>
          </Space>
        </div>
      </GenericModal>
    </>
  );
};

export default RestrictedFeatureModal;
